export class UserLevelBenefitRequest {
    constructor() {
        this.status = 'INITIALIZING';
    }
}
//# sourceMappingURL=userLevelBenefitRequest.js.map